import type {TMedicineRp} from '@app/types';
import {useMemo, type FC} from 'react';
import {Col, List, Row, Space, Typography} from 'antd';
import MedicineTag from './MedicineTag';
import {EMedicineStatus} from '@app/constants';

const {Text} = Typography;

const MedicineRp: FC<TMedicineRp & {isLoading: boolean}> = (props) => {
  const {
    medicines,
    rp_number,
    rp_directions,
    rp_intake_frequency,
    rp_intake_unit,
    rp_intake_per_day,
    rp_type,
    isLoading,
  } = props;

  const header = useMemo(() => {
    if (!rp_number) return null;

    return (
      <Row justify="space-between">
        <Col span={16}>
          <Text type="secondary">
            RP{rp_number} {rp_type && `[${rp_type}]`} {rp_directions}
          </Text>
        </Col>
        <Col span={8} style={{textAlign: 'end'}}>
          <Space>
            {!!rp_intake_per_day && (
              <Text type="secondary">1日{rp_intake_per_day}回</Text>
            )}
            {!!rp_intake_unit && (
              <div>
                <Text type="secondary">{rp_intake_frequency}</Text>
                <Text type="secondary">{rp_intake_unit}</Text>
              </div>
            )}
          </Space>
        </Col>
      </Row>
    );
  }, [
    rp_number,
    rp_directions,
    rp_intake_frequency,
    rp_intake_unit,
    rp_intake_per_day,
    rp_type,
  ]);

  return (
    <List
      header={header}
      dataSource={medicines}
      size="small"
      bordered
      loading={isLoading}
      style={{marginBottom: 16}}
      renderItem={(item) => (
        <List.Item>
          <Row style={{width: '100%'}} justify="space-between">
            <Col span={16}>
              <Text
                type={
                  item.status === EMedicineStatus.AUDIT_NOT_REQUIRED
                    ? 'secondary'
                    : undefined
                }
                strong
              >
                {item.actual_name}
              </Text>
            </Col>
            <Col
              span={8}
              style={{
                display: 'flex',
                alignItems: 'end',
                flexDirection: 'column',
              }}
            >
              <MedicineTag {...item} />
              <Text style={{textAlign: 'end'}}>
                {!!item.intake_amount &&
                  !!rp_intake_unit &&
                  `${item.intake_amount}${item.unit}/${rp_intake_unit} `}
                {item.dosage}
                {item.unit}
              </Text>
            </Col>
          </Row>
        </List.Item>
      )}
    />
  );
};

export default MedicineRp;
